var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    ref: "modal",
    attrs: {
      "show-on-mount": "",
      options: { close: { onBlur: false, onEsc: false } },
      size: _vm.size
    },
    on: {
      hide: function($event) {
        return _vm.$emit("hide", $event)
      },
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "modal-title",
          fn: function() {
            return [_vm._t("title")]
          },
          proxy: true
        },
        {
          key: "modal-body",
          fn: function() {
            return [_vm._t("body")]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c("settings-controls", {
                attrs: {
                  invalid: _vm.invalid,
                  "delete-button-text": _vm.resources.deleteButtonText
                },
                on: {
                  save: function($event) {
                    return _vm.onSave()
                  },
                  cancel: function($event) {
                    return _vm.hide()
                  },
                  delete: function($event) {
                    return _vm.$emit("delete")
                  }
                }
              })
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }